import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

export function omit<T, K extends keyof T>(obj: T, keys: K[]): Omit<T, K> {
  const clone = { ...obj };
  for (const key of keys) {
    delete clone[key];
  }
  return clone;
}

export function pad(value: number): string {
  return String(value).padStart(2, '0');
}

export function getTime(date: NgbDateStruct): number {
  return (new Date(`${date.year}-${date.month}-${date.day}`)).getTime();
}

export function dateToStringDate(date: NgbDateStruct): string {
  return `${pad(date.year)}-${pad(date.month)}-${pad(date.day)}`;
}
